import React from 'react'
import { Container, Grid, styled } from '@mui/material'
import theme from '../../config/styles/theme'

export const Wrapper = styled(Container)``
export const GridWrapper = styled(({ align, borderTop, margin, padding, ...props }) => <Grid {...props} />)`
  margin: ${props => props.margin};
  padding: ${props => props.padding};
  border-top: ${props => (props.borderTop ? '2px solid' + theme.palette.brand.gray2 : null)};
  text-align: ${props => props.align};

  &.MuiGrid-item {
    margin: ${props => props.margin};
  }

  &.icon-container {
    padding: 16px 0;
    display: flex;
    align-items: flex-end;
    justify-content: center;
  }

  ${props => props.theme.breakpoints.up('sm')} {
    &.icon-container {
      padding: 32px 0 0;
    }
  }
`
export const Info = styled('span')`
  font-size: 12px;
  line-height: 16px;
  text-decoration: underline;
  cursor: pointer;
`
export const DetailWrap = styled('div')`
  position: relative;
  display: inline-block;
  zoom: 1;
  margin: 0;
`
export const PercentageDetail = styled('span')`
  padding-left: 4px;
`

export const TypeIcon = styled('img')`
  position: relative;
  display: inline-block;
  zoom: 1;
  margin: 0 8px 0 0;
`
export const Link = styled('a')`
  color: ${props => props.theme.palette.brand.primary}

  &:hover{
    color: ${props => props.theme.palette.blue[35]}
  }

  &:visited{
    color: ${props => props.theme.palette.brand.primary}
  }
`

export const Exportable = styled('div')``
